"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompletedLevelsResponseToJSON = exports.GetCompletedLevelsResponseFromJSONTyped = exports.GetCompletedLevelsResponseFromJSON = void 0;
function GetCompletedLevelsResponseFromJSON(json) {
    return GetCompletedLevelsResponseFromJSONTyped(json, false);
}
exports.GetCompletedLevelsResponseFromJSON = GetCompletedLevelsResponseFromJSON;
function GetCompletedLevelsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'completedLevels': json['completedLevels'],
    };
}
exports.GetCompletedLevelsResponseFromJSONTyped = GetCompletedLevelsResponseFromJSONTyped;
function GetCompletedLevelsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'completedLevels': value.completedLevels,
    };
}
exports.GetCompletedLevelsResponseToJSON = GetCompletedLevelsResponseToJSON;
